import { render, staticRenderFns } from "./FooterPartners.vue?vue&type=template&id=4afe360d"
import script from "./FooterPartners.vue?vue&type=script&lang=js"
export * from "./FooterPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports